import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useSubscription } from '@/common/hooks';
import Metrics from '../components/Metrics';
import { DashboardPage as DashboardPageWrapper } from '../components/PremiumDesign';
import { getDashboardStats } from '../api';
import RecentCampaigns from '../components/RecentCampaigns';
import { SubscriptionExpired } from '../components/SubscriptionExpired';

export function DashboardPage() {
  const { isExpired } = useSubscription();

  const getCompanyId = () => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const userObj = JSON.parse(storedUser);
        return userObj?.company_id || localStorage.getItem('company_id');
      }
    } catch (e) {
      console.error('Failed to parse user object from localStorage', e);
    }
    return localStorage.getItem('company_id');
  };

  const companyId = getCompanyId();

  // Query: Fetch dashboard statistics (disabled when subscription has expired)
  const {
    data: stats,
    isLoading: isStatsLoading,
    isFetching: isStatsFetching,
    isError,
    error: statsError,
  } = useQuery({
    queryKey: ['dashboard-stats', companyId],
    queryFn: () => getDashboardStats(companyId),
    enabled: !!companyId && !isExpired,
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    // Only display error toast if not expired (replaces small error banner)
    if (isError && !isExpired) {
      toast.error(
        statsError?.response?.data?.code ||
          statsError?.response?.data?.detail ||
          statsError?.message ||
          'Failed to load statistics',
      );
    }
  }, [isError, statsError, isExpired]);

  // When subscription has expired, render modern full-page SubscriptionExpired card
  if (isExpired) {
    return <SubscriptionExpired />;
  }

  return (
    <DashboardPageWrapper className="!h-full min-h-0 flex-1 overflow-y-auto custom-scrollbar !bg-transparent !p-0">
      <div className="dashboard-top-stack flex min-h-0 w-full flex-1 flex-col gap-4 pb-4">
        <Metrics
          stats={stats}
          isLoading={isStatsLoading}
          isFetching={isStatsFetching}
        />
        <RecentCampaigns companyId={companyId} />
      </div>
    </DashboardPageWrapper>
  );
}
